export default {
  mainContainer: {
    display: 'flex',
  },
  pageContentContainer: {
    padding: '20px',
    width: '100%',
    // min-width: 0 lets this flex item shrink so content wraps instead of overflowing.
    minWidth: 0,
    overflowWrap: 'break-word',
  },
  // The skip link focuses <main>; it is a target, not a control, so no ring.
  mainContainerFocusTarget: {
    '&:focus': { outline: 'none' },
  },
};
